import { API_ENDPOINT } from './config';

export const urlsPortalManagement = {
  // Users, roles, permissions
  permissions: `${API_ENDPOINT}/permissions`,
  roles: `${API_ENDPOINT}/roles`,
  extPartnersRoles: `${API_ENDPOINT}/ec-roles`,
  extUsersRoles: `${API_ENDPOINT}/eu-roles`,
  roleDetail: (id) => `${API_ENDPOINT}/roles/${id}`,
  users: `${API_ENDPOINT}/users`,
  userWriters: `${API_ENDPOINT}/users?writers=true`,
  studentUsers: `${API_ENDPOINT}/users?student=true`,
  newsUsers: `${API_ENDPOINT}/users?news=true`,
  articleAuthors: `${API_ENDPOINT}/users?articleAuthors=true`,
  userDetail: (id) => `${API_ENDPOINT}/users/${id}`,
  updateLoggedUser: (id) => `${API_ENDPOINT}/users/updateLoggedUser/${id}`,
  usersStack: `${API_ENDPOINT}/usersStack`,

  // Departments and contacts
  contacts: `${API_ENDPOINT}/usercontacts`,
  departments: `${API_ENDPOINT}/departments`,
  departmentDetail: (slug) => `${API_ENDPOINT}/departments/${slug}`,

  // Mail
  contactMail: `${API_ENDPOINT}/mail/contact`,
  congratulationsMail: `${API_ENDPOINT}/mail/congratulations`,
  questionToApplicationMail: `${API_ENDPOINT}/mail/questionToApplication`,
  feedbackMail: `${API_ENDPOINT}/mail/feedback`,

  // Job offers (general CMS job offers, not FriJobs)
  jobOffers: `${API_ENDPOINT}/job-offers`,
  jobOfferDetail: (id) => `${API_ENDPOINT}/job-offers/${id}`,
  actuallyJobOffers: `${API_ENDPOINT}/job-offers/actually-job-offers`,

  // Logs
  logs: `${API_ENDPOINT}/logs`,
  logsDetail: (id) => `${API_ENDPOINT}/logs/${id}`,

  // LDAP
  ldapSynchronization: `${API_ENDPOINT}/synchronization`,
  ldapLastSyncResult: `${API_ENDPOINT}/last-sync-result`,

  // Frontend build version
  appVersion: `${API_ENDPOINT}/app-version`,

  //help
  help: `${API_ENDPOINT}/help`,
  helpDetail: id => `${API_ENDPOINT}/help/${id}`,
  helpByUrlAndSlug: (url, slug) =>
    `${API_ENDPOINT}/help/custom?url=${encodeURIComponent(url)}&slug=${encodeURIComponent(slug)}`
};

export const routesPortalManagement = {
  // CMS
  cmsDashboard: '/cms',
  cmsAccountChoose: '/cms/login-as-user',

  // Departments management
  cmsDepartments: '/cms/departments',
  cmsDepartmentEdit: '/cms/departments/edit',

  // Users, roles, permissions
  cmsPermissions: '/cms/permissions',
  cmsRoles: '/cms/roles',
  cmsRolesDetail: '/cms/roles/detail',
  cmsRolesCreate: '/cms/roles/create',
  cmsUsers: '/cms/users',
  cmsUsersEdit: '/cms/users/edit-role',
  cmsUserProfileEdit: '/cms/users/edit-profile',

  // Logs & menu
  cmsLogs: '/cms/logs',
  cmsLogsDetail: '/cms/logs',

  //help
  cmsHelp: '/cms/help',
  cmsHelpCreate: '/cms/help/create',
  cmsHelpEdit: '/cms/help/edit'


};
